import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { initAnalytics } from './analytics';
import './styles.css';

initAnalytics();

const container = document.getElementById('root');

if (!container) {
    throw new Error('The #root container is missing from index.html');
}

createRoot(container).render(
    <StrictMode>
        <App />
    </StrictMode>,
);
